import { Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';

const CustomDataTable = ({ columns, data, progressPending,pagination,paginationRowsPerPageOptions=[15], paginationServer, paginationTotalRows,onChangeRowsPerPage, expandableRows=false,onChangePage, expandableRowDisabled=false , expandableRowsComponent }) => {
	return (
		<>
			<DataTable
				columns={columns}
				responsive
				striped
				data={data}
				progressPending={progressPending}
				progressComponent={<div><Spinner  animation="border" variant="success" /></div>}
				//exapand rows
				expandableRows={expandableRows} expandableRowsComponent={expandableRowsComponent}

				//pagination
				pagination={pagination} paginationServer={paginationServer} paginationTotalRows={paginationTotalRows} onChangeRowsPerPage={onChangeRowsPerPage} onChangePage={onChangePage} 
				paginationRowsPerPageOptions={paginationRowsPerPageOptions}
			/>
		</>
	);
};

export default CustomDataTable;